import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {AppSettingsService} from '../../../services/app-settings.service';
import {ExternalEmployeeService} from '../../../services/external-employee.service';
import {StaticMethods} from '../../../model/GeneralModels';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: [
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css'
  ]
})
export class HomeComponent implements OnInit {
  productList: {productName: string, requestCount: number}[];
  translation: any = {};
  constructor(private router: Router, public settings: AppSettingsService,
              private service: ExternalEmployeeService) { }

  ngOnInit() {
    this.service.getEmployeeProducts().subscribe(response => {
      console.log(response);
      if (response.success) {
        this.productList = [];
        this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
        response.data.forEach(product => {
          this.productList.push({
            productName: product.productName,
            requestCount: product.requestCount
          });
        });
      }
    });
  }

  goToProduct(product: { productName: string; requestCount: number }) {
    this.router.navigate([`/external-employee/${product.productName}`]);
  }
}
